import { StrictMode } from "react";
import "@ant-design/v5-patch-for-react-19"; 
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./AzureAdLogin/AuthConfig.ts";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = new PublicClientApplication(msalConfig);

import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MsalProvider>
  </StrictMode>
);
